








































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import Empty from "@/components/empty.vue";
import { GetPracticeReport } from "@/request/common";
@Component({
  components: {
    Header,
    Empty,
  },
})
export default class Name extends Vue {
  private ifShowTip: any = false;
  private data: any = {};
  private pies: any = [];
  private levelData: any = {};
  private pieBase: any = {
    grid: {},
    tooltip: {
      formatter: (params: any) => {
        if (params.dataIndex === 1) {
          return "";
        } else {
          return params.name + ":" + params.percent + "%";
        }
      },
    },
    series: [
      {
        type: "pie",
        data: [],
        label: {
          position: "center",
          formatter: (params: any) => {
            if (params.dataIndex === 1) {
              return "";
            } else {
              return params.value;
            }
          },
          fontSize: 26,
        },
        radius: ["50%", "70%"],
      },
    ],
  };
  private pieColors: any = [
    "#50A7F9",
    "#69D688",
    "#FEDB57",
    "#BA95F8",
    "#F4AF6E",
    "#F88AA9",
  ];
  private get user() {
    return this.$store.state.user;
  }
  private getLv(val: any) {
    let result: any = (val * 100).toFixed(0);
    if (result) {
      result += "%";
    }
    return result;
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetPracticeReport(this, loading).then((res: any) => {
      this.data = res;
      this.pies = [];
      const d: any = [
        {
          ratio: res["各维度正确率"]["舌"],
          title: "舌",
          value: res["各维度正确率"]["舌"],
        },
        {
          ratio: res["各维度正确率"]["面"],
          title: "面",
          value: res["各维度正确率"]["面"],
        },
      ];
      d.forEach((item: any, index: any) => {
        const tempPie: any = JSON.parse(JSON.stringify(this.pieBase));
        tempPie.tooltip = {
          formatter: (p: any) => {
            if (p.dataIndex === 1) {
              return "";
            } else {
              return p.data.title + ":" + p.percent + "%";
            }
          },
        };
        // item.name = item.title + "\n" + item.value;
        const dataObj: any = JSON.parse(JSON.stringify(item));
        tempPie.title = {
          text:
            "{name|" +
            item.title +
            "}\n{val|" +
            (item.value * 100).toFixed(0) +
            "%" +
            "}",
          // text: "{name|" + item.title + "}\n{val|" + item.value + "}",
          top: "center",
          left: "center",
          textStyle: {
            rich: {
              name: {
                fontSize: 20,
                fontWeight: "bold",
                color: "#333",
                padding: [10, 0],
              },
              val: {
                fontSize: 26,
                fontWeight: "bold",
                color: "#333333",
              },
            },
          },
        };
        tempPie.color = [this.pieColors[index], "#ECE9EC"];
        if (item.value) {
          // tempPie.color = [this.pieColors[index], "#ECE9EC"];
          tempPie.color = ["#69D688", "#ECE9EC"];
        } else {
          tempPie.color = ["#ECE9EC", "#ECE9EC"];
        }
        tempPie.series[0].data = [
          dataObj,
          { name: "", value: dataObj.value / dataObj.ratio - dataObj.value },
        ];
        this.pies.push(tempPie);
      });
    });
  }
  private mounted() {
    this.getData();
  }
}
